<template>
  <a-form-model ref="form" :model="formdata" :rules="rules" v-bind="layout">
    <a-form-model-item label="当前密码" prop="oldpwd">
      <a-input-password v-model="formdata.oldpwd" autocomplete="off" placeholder="请输入当前密码" />
    </a-form-model-item>
    <a-form-model-item label="新密码" prop="newpwd">
      <a-input-password v-model="formdata.newpwd" autocomplete="off" placeholder="请输入新密码" />
    </a-form-model-item>
    <a-form-model-item label="确认密码" prop="rnewpwd">
      <a-input-password v-model="formdata.rnewpwd" autocomplete="off" placeholder="请输入再次输入新密码" />
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }">
      <a-button type="primary" @click="onSubmit" block>保存</a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { mapActions } from "vuex";
const defaultFormdata = {
  oldpwd: "",
  newpwd: "",
  rnewpwd: "",
};
export default {
  data() {
    return {
      formdata: Object.assign({}, defaultFormdata),
      rules: {
        oldpwd: [
          { required: true, message: "请输入当前密码", trigger: "blur" },
          { min: 6, message: "请输入至少输入六位", trigger: "blur" },
        ],
        newpwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "请输入至少输入六位", trigger: "blur" },
        ],
        rnewpwd: [
          { required: true, message: "请输入再次输入新密码", trigger: "blur" },
          { min: 6, message: "请输入至少输入六位", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value == this.formdata.newpwd) {
                callback();
              } else {
                callback(new Error("两次输入密码不一致"));
              }
            },
            message: "两次输入密码不一致",
            trigger: "blur",
          },
        ],
      },
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
      },
    };
  },
  methods: {
    ...mapActions("user", ["updatePassword"]),
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const response = await this.updatePassword(this.formdata);
          if (response && response.code == 200) {
            this.$emit("success", response);
          }
        }
      });
    },
    resetFormdata() {
      this.formdata = Object.assign({}, defaultFormdata);
    },
  },
};
</script>
